import React, { useEffect } from "react";
import ReactDOM from "react-dom";

export default function MatkaBetReviewModal({
  show,
  title,
  rows,
  totalPoints,
  error,
  submitting,
  canSubmit,
  onClose,
  onConfirm,
}) {
  useEffect(() => {
    if (!show) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [show]);

  if (!show) return null;

  const showSubType = rows.some((row) => row.subType);
  const modalContent = (
    <div
      className="matka-bet-review-overlay"
      onClick={submitting ? undefined : onClose}
      role="presentation"
    >
      <div
        className="matka-bet-review-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="matka-bet-review-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="matka-bet-review-close"
          onClick={onClose}
          disabled={submitting}
          aria-label="Close"
        >
          &times;
        </button>

        <div className="matka-bet-review-heading">
          <div id="matka-bet-review-title" className="matka-bet-review-title">
            {title || "Confirm Bet"}
          </div>
          <p className="matka-bet-review-subtitle">
            <span>{rows.length}</span> {rows.length === 1 ? "bid" : "bids"}
            <span className="matka-bet-review-dot">·</span>
            <span>{totalPoints.toLocaleString()}</span> points
          </p>
        </div>

        <div className="matka-bet-review-table-wrap">
          <table className="matka-bet-review-table">
            <thead>
              <tr>
                <th>Selection</th>
                {showSubType && <th>Type</th>}
                <th className="is-points">Points</th>
                <th className="is-type">Game Type</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td>{row.selection}</td>
                  {showSubType && <td>{row.subType}</td>}
                  <td className="is-points">{row.points.toLocaleString()}</td>
                  <td className="is-type">{row.gameType}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {error && <p className="matka-bet-review-error">{error}</p>}

        <div className="matka-bet-review-actions">
          <button
            type="button"
            className="matka-bet-review-cancel"
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="matka-bet-review-confirm"
            onClick={onConfirm}
            disabled={!canSubmit || submitting}
          >
            {submitting ? "Placing..." : "Continue"}
          </button>
        </div>
      </div>
    </div>
  );

  if (typeof document !== "undefined" && document.body) {
    return ReactDOM.createPortal(modalContent, document.body);
  }

  return modalContent;
}
